/**
 * Shared rules for canvas object move on pointer-down (shapes + text).
 * When the user was already multi-selected and clicks one of those items,
 * a drag moves the whole prior selection; otherwise only the clicked item moves.
 */
export function shouldDragMultiFromPriorSelection(
  priorSelectedIds: readonly string[],
  clickedId: string
): boolean {
  return priorSelectedIds.length > 1 && priorSelectedIds.includes(clickedId)
}
